const utils = require('frontend-controller/lib/utils')

/*
    this is one variant of a static form.
    it contains static fields without any db-data and is used to select a timeRange without any server-requests.
 */

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'form',
    ],

    formMapping: {
        cols: [[{
            type: 'tag',
            tag: 'p',
            messageKey: 'prices.showSelectTimeRangeIntro'
        },{
            type: 'fieldGroup',
            source: 'resourceFields'
        }]]
    },

    config: {
        resourceConnected: false
    },

    model: {
        // config: {
        //     fields: {
        //         timeRange: {
        //             momentDateFormat: 'DD.MM.YYYY HH:mm', // format to use for timestamp-labels
        //             showUsageTooltip: true, // the usage tooltip shows all formats regardless of the grantedFormat. one might turn it off here to prevent confusion.
        //             grantedFormat: { // which formats should be supported. non-granted formats will be translated if possible.
        //                 month: true,
        //                 quarter: true,
        //                 year: true,
        //             },
        //         }
        //     }
        // },

        fields: [
            {
                fieldCode: 'timeRange',
                config: {
                    // momentDateFormat: 'DD.MM.YYYY HH:mm',
                    separatedFieldCodes: {
                        code: 'code',
                        from: 'from',
                        to: 'to',
                    }
                },
                atom: {
                    code: 'TIME_RANGE_BY_CODE',
                    dataType: 'json',
                    renderType: 'timeRangeByCode',
                },
                lang: {
                    'de-at': {
                        label: 'Zeitraum'
                    }
                },
            },
            {
                fieldCode: 'code',
                atom: {
                    code: 'HIDDEN_TEXT',
                    dataType: 'text',
                    renderType: 'none',
                },
            },
            {
                fieldCode: 'from',
                atom: {
                    code: 'HIDDEN_DATETIME',
                    dataType: 'datetime',
                    renderType: 'none',
                },
            },
            {
                fieldCode: 'to',
                atom: {
                    code: 'HIDDEN_DATETIME',
                    dataType: 'datetime',
                    renderType: 'none',
                },
            },
        ]
    },

    methods: {
        prepare(){
            const fieldConfig = this.model.config || {}
            for(const fieldCode in fieldConfig.fields || {}){
                utils.forEach(this.model.fields || [], (field, modelFieldIndex) => {
                    if(field.fieldCode === fieldCode){
                        utils.refMerge(field.config, fieldConfig.fields[fieldCode])

                        // hide options which should be available instead of disabling them.
                        if(field.config.disabled){
                            this.model.fields.splice(modelFieldIndex, 1)
                        }
                        return false
                    }
                })
            }
        },
    },

    hooks: {
        onDecision($element, options){
            options = options || {}
            const decisionOptions = options.decisionOptions || {}

            if(options.decisionType === 'decisionComponent' && decisionOptions.mode === 'select'){
                decisionOptions.timeRange = ((this.model.dirtyFields || {}).data || {}).attributes || {}
                let initiatorFound = false
                this.locate('< base_modal_modal < *', initiator => {
                    initiatorFound = true
                    options.decisionTriggerComponent = this
                    initiator.trigger('onDecision', options)
                })

                if(!initiatorFound){
                    console.error('missing initiator')
                }
            }
        }
    },
}